var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIls = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5173 9.66118H13.505L11.9989 7.05249L10.4928 9.66118H7.48047L8.98675 12.2699L7.48047 14.8785H10.4928L11.9989 17.4872L13.505 14.8785H16.5173L15.011 12.2699L16.5173 9.66118ZM13.8493 12.2699L12.9242 13.8724H11.0738L10.1485 12.2699L11.0737 10.6673H12.9241L13.8493 12.2699ZM11.9989 9.06469L12.3432 9.66113H11.6546L11.9989 9.06469ZM9.22324 10.6673H9.91192L9.56758 11.2637L9.22324 10.6673ZM9.22324 13.8724L9.56763 13.276L9.91197 13.8724H9.22324ZM11.9989 15.475L11.6546 14.8785H12.3432L11.9989 15.475ZM14.7746 13.8724H14.0859L14.4303 13.276L14.7746 13.8724ZM14.0859 10.6673H14.7746L14.4302 11.2637L14.0859 10.6673Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4703 2.87671H4.53058C3.43544 3.74896 2.49625 4.80843 1.76172 6.00716H22.2392C21.5046 4.80847 20.5654 3.74896 19.4703 2.87671Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53058 21.6595H19.4702C20.5654 20.7873 21.5046 19.7278 22.2391 18.5291H1.76172C2.4963 19.7277 3.43548 20.7873 4.53058 21.6595Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIls);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ILS.16ed467d90cb7eef8bbc92b76bf027cf.svg";